document.addEventListener( "DOMContentLoaded", () => {
	MicroModal.init( {
		disableScroll: true, // [5]
		disableFocus: false, // [6]
		awaitOpenAnimation: true, // [7]
		awaitCloseAnimation: true, // [8]
		debugMode: false // [9]
	} );
} );